import type { IActionCard } from '../ui/ActionCard';

import { solutions } from './solutions.enum';

export const solutionsMap: Record<(typeof solutions)[number], IActionCard> = {
  backup: {
    title: 'Software Backup',
    description: 'Secure your application for internal recovery.',
    buttonLink: '/backups',
    activeLabel: 'Backups',
    activeColor: 'text-accent-software-backup',
  },
  softwareEscrow: {
    title: 'Software Escrow',
    description: 'Securely store your software assets, ready for quick recovery.',
    buttonLink: '/software-escrows',
    activeLabel: 'Escrows',
    activeColor: 'text-accent-software-escrow',
  },
  saasEscrow: {
    title: 'SaaS Escrow',
    description: 'Ensure continuity protection for your cloud-native applications.',
    buttonLink: '/saas-escrows',
    activeLabel: 'Escrows',
    activeColor: 'text-accent-saas-escrow',
  },
  continuity: {
    title: 'Continuity Escrow',
    description: 'Ensure continuity protection for your cloud-native applications.',
    buttonLink: '/continuity-escrows',
    activeLabel: 'Escrows',
    activeColor: 'text-accent-continuity-escrow',
  },
};
